/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ApproveSkillSuggestionRequestBody = {
  /**
   * Optional IDs of the proposed changes to take together as one new version. The suggestion stays open carrying whatever is left. Cannot be combined with edited content.
   */
  changeIds?: Array<string> | undefined;
  /**
   * Optional edited complete SKILL.md content. Handlers enforce a maximum size of 65,536 UTF-8 bytes.
   */
  content?: string | undefined;
  /**
   * The suggestion ID.
   */
  id: string;
};

/** @internal */
export type ApproveSkillSuggestionRequestBody$Outbound = {
  change_ids?: Array<string> | undefined;
  content?: string | undefined;
  id: string;
};

/** @internal */
export const ApproveSkillSuggestionRequestBody$outboundSchema: z.ZodMiniType<
  ApproveSkillSuggestionRequestBody$Outbound,
  ApproveSkillSuggestionRequestBody
> = z.pipe(
  z.object({
    changeIds: z.optional(z.array(z.string())),
    content: z.optional(z.string()),
    id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      changeIds: "change_ids",
    });
  }),
);

export function approveSkillSuggestionRequestBodyToJSON(
  approveSkillSuggestionRequestBody: ApproveSkillSuggestionRequestBody,
): string {
  return JSON.stringify(
    ApproveSkillSuggestionRequestBody$outboundSchema.parse(
      approveSkillSuggestionRequestBody,
    ),
  );
}
